module.exports = __webpack_public_path__ + "img/about2.1c8dab7.png";